import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Episodes from "./pages/Episodes";
import Episode from "./pages/Episode";
import Topic from "./pages/Topic";
import TopicsLanding from "./pages/TopicsLanding";
import Community from "./pages/Community";
import Article from "./pages/Article";
import Saved from "./pages/Saved";
import Resources from "./pages/Resources";
import Book from "./pages/Book";
import HeroPreview from "./pages/HeroPreview";
import { Toaster } from "./components/ui/sonner";
import { AudioPlayerProvider } from "./context/AudioPlayerContext";
import StickyAudioBar from "./components/StickyAudioBar";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <AudioPlayerProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/episodes" element={<Episodes />} />
            <Route path="/episode/:id" element={<Episode />} />
            <Route path="/topics" element={<TopicsLanding />} />
            <Route path="/community" element={<Community />} />
            <Route path="/topics/:slug" element={<Topic />} />
            <Route path="/article/:slug" element={<Article />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<Book />} />
            <Route path="/saved" element={<Saved />} />
            <Route path="/hero-preview" element={<HeroPreview />} />
          </Routes>
          <StickyAudioBar />
        </AudioPlayerProvider>
      </BrowserRouter>
      </HelmetProvider>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
